import { render, staticRenderFns } from "./ChipDateField.vue?vue&type=template&id=81a50c7a"
import script from "./ChipDateField.vue?vue&type=script&lang=js"
export * from "./ChipDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports